// What No / SCAM does and needs, in five numbered blocks (10-1 mockup,
// QA_NuV_Getting Started). One source for the two places that show it: the
// header's Get Started panel and the /get-access page. `column` is the desktop
// column a block sits in inside the header panel; the page lays them out itself.

export const GET_STARTED_TAGLINE = 'Easy to use. Easy to love.';

export const GET_STARTED_INTRO =
  'Reclaim your surfing experience by turning your browser into a ScamAware browser. Experience what being truly ScamAware feels like. This next generation scammer prevention tool is unmatched — don’t fall for being a scammer’s next unsuspecting victim.';

export const GET_STARTED_BLOCKS = [
  {
    column: 0,
    heading: 'Internet Browsing Threat Warning',
    items: [
      'Actionable website threat information at your fingertips.',
      'Visual color-code SCI assignment.',
      'Phishing / Smishing detection and countermeasures.',
    ],
  },
  {
    column: 1,
    heading: 'Report a scammer',
    items: ['One click FBI / IRS / SSA / FTC fraud complaint filing.'],
  },
  {
    column: 1,
    heading: 'Scammer dark psychology screening',
    items: [
      'Private, personalized scam self-assessment.',
      'Vulnerability score.',
      'Focus > Romance & Crypto.',
    ],
  },
  {
    column: 1,
    heading: 'Prevention tools',
    items: [
      'Deepfake detection – video, image and audio.',
      'One click internet image search.',
    ],
  },
  {
    column: 2,
    heading: 'Requirements',
    items: [
      'One license per computer.',
      'Browser compatibility – Chrome / Edge.',
      'Device – PC / Laptop / Tablet.',
      'OS – Windows.',
    ],
  },
];
